import * as React from 'react';

import Spinner from 'components/spinner/spinner.component';
import './button.styles.less';

export default class Button extends React.Component<IButtonProps> {
    public static defaultProps: Partial<IButtonProps> = {
        type: 'primary',
        disabled: false
    };

    public handleClick = (e: React.SyntheticEvent<HTMLButtonElement>): void => {
        if (!this.props.disabled && !this.props.loading && this.props.onClick) {
            this.props.onClick(e);
        }
    };

    public render(): JSX.Element {
        const { disabled, shouldInheritStyles } = this.props;
        return (
            <button
                className={this.getButtonClass(shouldInheritStyles)}
                onClick={this.handleClick}
                disabled={disabled}
            >
                {this.getContent()}
            </button>
        );
    }

    public getContent(): React.ReactNode {
        return this.props.loading ? <Spinner /> : this.props.children;
    }

    public getButtonClass(shouldInheritStyles: boolean = false): string {
        let classList: string[];

        if (shouldInheritStyles) {
            classList = ['sitegen-button__embedded', `sitegen-button--${this.props.type}__embedded`, 'btn'];
            if (this.props.type === 'primary') {
                classList.push('btn-primary'); 
            }

            if (this.props.loading) {
                classList.push('sitegen-button--processing__embedded');
            }
        } else {
            classList = ['sitegen-button', `sitegen-button--${this.props.type}`];

            if (this.props.compact) {
                classList.push('sitegen-button--compact');
            }

            if (this.props.loading) {
                classList.push('sitegen-button--processing');
            }
        }

        if (this.props.className) {
            classList.push(this.props.className);
        }

        return classList.join(' ');
    }
}

export interface IButtonProps {
    readonly type: 'primary' | 'secondary';
    readonly compact?: boolean;
    readonly loading?: boolean;
    readonly disabled?: boolean;
    readonly shouldInheritStyles?: boolean;
    readonly onClick?: (e: React.SyntheticEvent<HTMLButtonElement>) => void;
    readonly className?: string;
}
